export default function isWithin24Hours(date1, date2) {
	const timeDifference = Math.abs(date2 - date1);
	const hoursDifference = timeDifference / (1000 * 60 * 60);
	return hoursDifference <= 24;
}